export const Constants = {
  MASU_W: 43,
  MASU_H: 48,
  BOARD_W: 410,
  BOARD_H: 454,
  RankSize: 9,
  FileSize: 9,
  BOARD_MERGIN: 11
};



/** WEBPACK FOOTER **
 ** ./client/constants.ts
 **/